import React, { useEffect, useRef } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import genericUtility from "../services/utility/GenericUtility";
import { AppDispatch, RootState } from "../dataManagement/uiDb/UiDb";
import { fetchProfile } from "../services/thunks/ProfileThunk";

const RequireAuth: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const token = genericUtility.getCookie("token");
  const profile = useSelector((state: RootState) => state.profile);

  const didRunRef = useRef(false);

  const handleInvalidToken = () => {
    genericUtility.deleteCookie("token");
    navigate("/welcome", { replace: true });
  };

  useEffect(() => {
    const validateUserAndFetchProfile = async () => {
      // Check token validity first
      if (!token) {
        handleInvalidToken();
        return;
      }
      if (profile && profile.data) {
        return;
      }
      try {
        // Fetch and validate profile
        dispatch(fetchProfile());
      } catch (error) {
        console.error("Profile validation failed:", error);
        handleInvalidToken();
      }
    };
    if (!didRunRef.current) {
      didRunRef.current = true;
      validateUserAndFetchProfile();
    }
  }, []);

  // Show loading state while validation is in progress
  return <div>{profile && profile.data && <Outlet />}</div>;
};

export default RequireAuth;
